<footer class="footer">
  <div class="footer__container">
    <div class="footer__content">
      <div class="footer__branding">
        <div class="footer__section">
          <h3 class="footer__title">
            <img src="/Logos/lexwood-beige.png" alt="Lexwood Solutions - Timber Flooring Sydney" class="footer__logo-icon">
          </h3>
          <p class="footer__description">
            Build beautiful, long-lasting timber floors with modern precision.
          </p>
        </div>
      </div>

      <div class="footer__links">
        <div class="footer__section">
          <h4 class="footer__subtitle">Quick Links</h4>
          <ul class="footer__list">
            @for (item of quickLinks; track $index) {
              <li class="footer__item">
                <a [href]="item.link"
                   class="footer__link"
                   (click)="onAnchorItemClick($event, item.link, item.scrollOptions)">
                  {{ item.title }}
                </a>
              </li>
            }
          </ul>
        </div>

        <div class="footer__section">
          <h4 class="footer__subtitle">Support</h4>
          <ul class="footer__list">
            @for (item of resourcesLinks; track $index) {
              <li class="footer__item">
                <a [href]="item.link"
                   class="footer__link"
                   (click)="onAnchorItemClick($event, item.link, item.scrollOptions)">
                  {{ item.title }}
                </a>
              </li>
            }
          </ul>
        </div>

        <div class="footer__section">
          <h4 class="footer__subtitle">Social</h4>
          <div class="footer__list">
            @for (social of socialLinks; track $index) {
              <li class="footer__item">
                <a [href]="social.link"
                   class="footer__link"
                   (click)="onAnchorItemClick($event, social.link, social.scrollOptions)">
                  {{ social.title }}
                </a>
              </li>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="footer__bottom">
      <p class="footer__copyright">
        © {{ currentYear }} Lexwood Solutions. All rights reserved.
      </p>
    </div>
  </div>
</footer>
